/**
 * Global Error Boundary (Root Layout)
 * aXai - Neurodivergent-Led Innovation
 * WCAG 2.2 AA Compliant
 */

'use client';

import { useEffect } from 'react';

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error('Global error:', error);
  }, [error]);

  return (
    <html lang="en">
      <body style={{ backgroundColor: '#1F1D2B', color: '#F6F3EE', fontFamily: 'system-ui, sans-serif' }}>
        <div style={{ display: 'flex', minHeight: '100vh', alignItems: 'center', justifyContent: 'center', padding: '2rem' }}>
          <div style={{ maxWidth: '32rem', textAlign: 'center' }}>
            <h1 style={{ fontSize: '2rem', fontWeight: 'bold', marginBottom: '1rem' }}>
              Something went wrong
            </h1>
            <p style={{ color: '#C9C3B8', marginBottom: '1.5rem' }}>
              An unexpected error has occurred. Please try again.
            </p>
            {error.digest && (
              <p style={{ color: '#C9C3B8', fontSize: '0.875rem', marginBottom: '1.5rem' }}>
                Error ID: <code>{error.digest}</code>
              </p>
            )}
            <button
              onClick={reset}
              style={{
                backgroundColor: '#6A3C8B',
                color: '#1F1D2B',
                padding: '0.5rem 1.5rem',
                borderRadius: '0.375rem',
                fontWeight: '600',
                border: 'none',
                cursor: 'pointer',
              }}
            >
              Try again
            </button>
          </div>
        </div>
      </body>
    </html>
  );
}
